import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './cover.styles'
import Paper from 'pobble-components/dist/paper'
import Intro from './intro/intro.container'
import Discussion from './discussion/discussion.container'
import Works from './works/works.container'
import Sidebar from './sidebar/sidebar'
import Spinner from 'pobble-components/dist/spinner'
import EditTitleDialog from '../../../shared/edit-title-dialog/edit-title-dialog.container'
import InviteesDialog from '../../../shared/invitees-dialog/invitees-dialog.container'

class Cover extends Component {
  componentDidMount() {
    this.props.onMount(this.props.id)
  }
  render() {
    const { classes, pending, assessmentFile } = this.props
    return (
      <Fragment>
        {!pending &&
          (assessmentFile && (
            <Paper className={classes.container}>
              <main className={classes.main}>
                <Intro />
                <Works />
                <Discussion />
              </main>
              <Sidebar />
            </Paper>
          ))}
        {pending && <Spinner className={classes.spinner} />}
        <EditTitleDialog />
        <InviteesDialog />
      </Fragment>
    )
  }
}

export default injectSheet(styles)(Cover)
